<template>
  <div :class="$style.container">
    <table
      v-show="tableData.length"
      :class="$style.table"
    >
      <TableHeader
        :columns="columns"
        :renderActionColumn="renderActionColumn"
      />
      <TableBodyWithCustomComponents
        :columns="columns"
        :itemType="itemType"
        :renderActionColumn="renderActionColumn"
        :tableData="tableData"
      />
    </table>
    <NoRecordsFound
      v-show="!tableData.length"
    />
  </div>
</template>

<script>
import { ItemTypeConsts } from 'client/util/Constants';
import { values } from 'lodash';
import NoRecordsFound from 'components/Tables/NoRecordsFound.vue';
import TableBodyWithCustomComponents from 'client/components/Tables/TableBodyWithCustomComponents.vue';
import TableHeader from 'components/Tables/TableHeader.vue';
import TableMixin from 'components/Tables/TableMixin';

export default {
  name: 'TableWithCustomColumns',

  components: {
    NoRecordsFound,
    TableBodyWithCustomComponents,
    TableHeader,
  },

  mixins: [
    TableMixin,
  ],

  props: {
    itemType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return values(ItemTypeConsts).indexOf(value) !== -1;
      },
    },
  },
};

</script>

<style scoped module>
@import './css/tableStyles.css';

</style>
